import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import {
  StyledCol,
  StyledInfoTextWrapper,
  StyledRow,
  StyledWrapper,
} from './styles'
import { Text } from '../../atoms/text'
import { FormatAmount } from '../../atoms/formatAmount'
import { useTranslation } from '../../../context/translationProvider'
import { AuthContext } from '../../../context/authProvider'
import { If } from '../../atoms/if'

export const WithdrawDetails = ({
  infoText,
  minimumAmount = 0,
  maximumAmount = 0,
}) => {
  const { translate } = useTranslation()
  const { user } = useContext(AuthContext)

  return (
    <StyledWrapper>
      <Text bold style={{ fontSize: 22, marginBottom: 5 }}>
        {translate('payments.information')}
      </Text>
      <StyledRow>
        <StyledCol>
          {translate('payments.minimum')}
          {': '}
          <FormatAmount
            amount={minimumAmount}
            shortCode={user?.wallet?.currency.short_code}
            maximumFractionDigits="0"
            useGrouping={minimumAmount.toString().length >= 5}
            currencySymbol={user?.wallet?.currency?.symbol}
          />
        </StyledCol>
        <StyledCol>
          {translate('payments.maximum')}
          {': '}
          <FormatAmount
            amount={maximumAmount}
            shortCode={user?.wallet?.currency.short_code}
            maximumFractionDigits="0"
            useGrouping={maximumAmount.toString().length >= 5}
            currencySymbol={user?.wallet?.currency?.symbol}
          />
        </StyledCol>
      </StyledRow>

      <If
        condition={!!infoText}
        render={() => <StyledInfoTextWrapper>{infoText}</StyledInfoTextWrapper>}
      />
    </StyledWrapper>
  )
}

WithdrawDetails.propTypes = {
  infoText: PropTypes.string,
  minimumAmount: PropTypes.number,
  maximumAmount: PropTypes.number,
}
